import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';
import { reduxForm, getFormValues } from 'redux-form';
import { connect } from 'react-redux';
import Modal from 'react-modal';
import {
  AddDocumentsContainer,
  FormAlert,
  FormCTAContainer,
  FormHeader,
  FormInfo,
  FormTitle,
  FromTitleContainer,
} from './css';
import UploadDocuments from '../../ReactComponent/UploadDocuments';
import SecondaryButton from '../../../lib/ui/buttons/SecondaryButton';
import PrimaryButton from '../../../lib/ui/buttons/PrimaryButton';
import ModalBoxStyle from '../../_styledComponents/ModalBoxStyle';
import { ModalBody, ModalTitle, ButtonDiv } from '../../CreateShipment/css';

class AddDocumentsForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fileErrorModal: false,
    };
    this.handleFileError = this.handleFileError.bind(this);
  }

  handleFileError() {
    this.setState({ fileErrorModal: true });
  }

  closeFileErrorModal = () => this.setState({ fileErrorModal: false });

  handleSubmitForm = (e) => {
    e.preventDefault();
    const { formData, handleSubmitFiles } = this.props;
    handleSubmitFiles(formData);
  };

  render() {
    const { formData } = this.props;
    const { fileErrorModal } = this.state;

    const documentsInputs = [
      { id: 'documentsUpload' },
    ];

    return (
      <>
        <AddDocumentsContainer onSubmit={this.handleSubmitForm}>
          <FormHeader>
            <FromTitleContainer>
              <FormTitle>{t('AddDocuments')}</FormTitle>
              <FormInfo>{t('MaxDocumentSize')}</FormInfo>
            </FromTitleContainer>
            <FormAlert>
              {t('UploadAlert')}
            </FormAlert>
          </FormHeader>
          <UploadDocuments
            documentFields={documentsInputs}
            attachedDocuments={formData && formData.attachedDocuments}
            onFileError={this.handleFileError}
          />
          <FormCTAContainer>
            <SecondaryButton showArrow={false} onClick={this.props.stopAddingDocuments}>{t('Cancel')}</SecondaryButton>
            <PrimaryButton type="submit" disabled={!formData}>{t('Upload')}</PrimaryButton>
          </FormCTAContainer>
        </AddDocumentsContainer>

        <Modal
          isOpen={fileErrorModal}
          onRequestClose={this.closeFileErrorModal}
          style={ModalBoxStyle}
          contentLabel="File Error Modal"
        >
          <ModalBody>
            <ModalTitle>{t('WarningTitle')}</ModalTitle>
            <p>{t('FileFormatPopupError')}</p>
            <ButtonDiv className="row no-gutters">
              <div className="col-sm-12">
                <SecondaryButton
                  name="acceptFileError"
                  label={t('Accept')}
                  onClick={this.closeFileErrorModal}
                />
              </div>
            </ButtonDiv>
          </ModalBody>
        </Modal>
      </>
    );
  }
}

AddDocumentsForm.propTypes = {
  handleSubmitFiles: PropTypes.func,
  stopAddingDocuments: PropTypes.func,
  formData: PropTypes.shape({
    attachedDocuments: PropTypes.object,
  }),
};

AddDocumentsForm = reduxForm({
  form: 'AddDocumentsForm',
})(AddDocumentsForm);

const mstp = (state) => ({
  formData: getFormValues('AddDocumentsForm')(state),
  completed: Boolean,
});

export default connect(mstp)(AddDocumentsForm);
